import { QueryClient } from "@tanstack/react-query"

// Factory so tests can mint an isolated QueryClient. refetchOnWindowFocus is off
// because WebSocket invalidation handles freshness.
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        retry: 1,
        refetchOnWindowFocus: false,
        refetchOnReconnect: true,
      },
      mutations: {
        retry: 0,
      },
    },
  })
}
